// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Promotion from '../components/Promotion/Promotion';
import {actions as ManualOrderActions} from '../../../manual-order/duck';
import {actions as CategoryActions} from '../../../categories/duck';
import {actions as PromotionsActions} from '../duck';
// import {actions as CouponsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    error: state.promotions.error,
    currency: state.currency.currency,
    productsFilter: state.manualOrder.products,
    paginationProducts: state.manualOrder.pagination,
    categoriesFilter: state.categories.categoriesFilter,
    isFetchingProducts: state.manualOrder.isFetchingProducts,
    isFetchingCategories: state.categories.isFetching,
    isSaving: state.promotions.isSaving,
    promotion: state.promotions.promotion,
    promotions: state.promotions.promotions,
    isFetchingPromotion: state.promotions.isFetchingPromotion,
    createPromotionSuccess: state.promotions.createPromotionSuccess,
    updatePromotionSuccess: state.promotions.updatePromotionSuccess,
    paginationCategories: state.categories.paginationFilter,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {...ManualOrderActions, ...CategoryActions, ...PromotionsActions},
      dispatch
    )
)(Promotion);
